<template>
  <div>
    <PersonalView cuerpoTecnico>
    </PersonalView>
  </div>
</template>

<script>
import PersonalView from '../components/PersonalView'

export default {
  components: {
    PersonalView
  }
}
</script>
